export const CAPPED_AGENT_LIST_MAX_VISIBLE = 30